import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Overview from "./components/Overview";
import System from "./components/System";
import WorldView from "./components/WorldView";
import Plot from "./components/Plot";
import Characters from "./components/Characters";
import Track from "./components/Track";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

const FAQ_JSONLD = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "恋爱辅助器漫画是什么类型的作品？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "它是一部以「恋爱系统」为设定的浪漫治愈系漫画，融合了校园日常、系统数值与个人成长元素。",
      },
    },
    {
      "@type": "Question",
      name: "恋爱辅助器系统到底是如何运作的？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "辅助器会实时显示心动值、好感度，并通过限时任务、道具商城与限时事件来引导主角与人相处，但真正的选择权始终在主角手中。",
      },
    },
    {
      "@type": "Question",
      name: "这部漫画的核心主题是什么？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "作品强调真实比技巧更重要，最终落点是真诚、勇气与自我和解，是一部看似在恋爱、实则谈成长的漫画。",
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(FAQ_JSONLD) }}
      />
      <Navbar />
      <main>
        <Hero />
        <Overview />
        <System />
        <WorldView />
        <Plot />
        <Characters />
        <Track />
        <Faq />
      </main>
      <Footer />
    </>
  );
}